// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 336) return "static/js/336.5e4af2c3.chunk.js";
	if (chunkId === 287) return "static/js/287.454be7b6.chunk.js";
	if (chunkId === 156) return "static/js/156.31ce1e43.chunk.js";
	if (chunkId === 533) return "static/js/533.4c57d599.chunk.js";
	if (chunkId === 446) return "static/js/reactPlayerYouTube.232c1670.chunk.js";
	if (chunkId === 979) return "static/js/reactPlayerSoundCloud.a2fe8148.chunk.js";
	if (chunkId === 173) return "static/js/reactPlayerVimeo.9b430eb9.chunk.js";
	if (chunkId === 723) return "static/js/reactPlayerMux.495acadc.chunk.js";
	if (chunkId === 887) return "static/js/reactPlayerFacebook.48721896.chunk.js";
	if (chunkId === 627) return "static/js/reactPlayerStreamable.fa72301a.chunk.js";
	if (chunkId === 340) return "static/js/reactPlayerWistia.2f5bc14d.chunk.js";
	if (chunkId === 42) return "static/js/reactPlayerTwitch.1aa45f61.chunk.js";
	if (chunkId === 328) return "static/js/reactPlayerDailyMotion.1ea15f64.chunk.js";
	if (chunkId === 570) return "static/js/reactPlayerMixcloud.d97a56a2.chunk.js";
	if (chunkId === 392) return "static/js/reactPlayerVidyard.a099923d.chunk.js";
	if (chunkId === 463) return "static/js/reactPlayerKaltura.bc5eb23d.chunk.js";
	if (chunkId === 458) return "static/js/reactPlayerFilePlayer.219a84fd.chunk.js";
	if (chunkId === 353) return "static/js/reactPlayerPreview.703fae2f.chunk.js";
	// return url for filenames based on template
	return undefined;
};